// 在线评估-受理
<template>
  <div class="shareUnitRanking-main">
    <div class="detail-popup-main">
      <div class="title">{{crtItem.eiaUnit}}</div>
      <div class="list-item">
        <div class="i-tcline">
          <span class="i-tcl-title">排名</span>
          <span class="i-tcl-content">{{crtItem.eiaRanking}}</span>
        </div>
        <div class="i-tcline">
          <span class="i-tcl-title">信用扣分</span>
          <span class="i-tcl-content">{{crtItem.creditDeduction}}</span>
        </div>
        <div class="i-tcline">
          <span class="i-tcl-title">环评师数量分</span>
          <span class="i-tcl-content">{{crtItem.eiaNumber}}</span>
        </div>
        <div class="i-tcline">
          <span class="i-tcl-title">环评数量</span>
          <span class="i-tcl-content">{{crtItem.eiaWordNum}}</span>
        </div>
        <div class="i-tcline">
          <span class="i-tcl-title">环评报告书数量</span>
          <span class="i-tcl-content">{{crtItem.eiaReportNum}}</span>
        </div>
        <div class="i-tcline">
          <span class="i-tcl-title">综合评分</span>
          <span class="i-tcl-content">{{crtItem.comRating}}</span>
        </div>
        <div class="i-tcline">
          <span class="i-tcl-title">智友投票</span>
          <span class="i-tcl-content">{{crtItem.votesNumbers}}</span>
        </div>
      </div>
      <div class="popup-btn-line">
        <el-button class="btn" type="primary" size="medium" @click="$router.push('/h5download')">投票</el-button>
        <el-button class="btn" type="primary" size="medium" @click="$router.push('/h5download')">更多</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index'
export default {
  data () {
    return {
      crtItem: {}
    }
  },
  created () {
    if (this.$route.query.id) {
      api.cdCreditScoreId({
        id: this.$route.query.id
      }).then(res => {
        if (res.code === 200) {
          this.crtItem = res.data
        }
      })
    }
  },
  mounted () {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style lang="scss">
.shareUnitRanking-main {
  width: 100%;
  height: 100%;
  .detail-popup-main {
    background-color: #f8f8f8;
    width: 80vw;
    padding: 10vw;
    .title {
      width: 100%;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      padding: 20px 0;
    }
    .list-item {
      width: 100%;
      .i-tcline {
        padding: 6px 0 4px 0;
        border-bottom: #ddd 0.5px solid;
        display: flex;
        justify-content: space-between;
        .i-tcl-title {
          font-size: 16px;
          font-weight: bold;
          margin-right: 8px;
        }
        .i-tcl-content {
          // text-align: right;
          font-size: 14px;
          word-break: break-all;
        }
      }
    }
    .popup-btn-line {
      width: 100%;
      height: calc(36px + 2 * 20px);
      text-align: center;
      margin: 0 auto;
      padding-top: 36px;
      .btn {
        height: 36px;
        width: 80px;
        font-size: 16px;
        margin: 0 10px;
      }
    }
  }
}
</style>
